// types
import { DefaultConfigProps } from "./types/config";
import DefaultProfilePhoto from "assets/images/users/DefaultProfilePhoto.png";

export const twitterColor = "#1DA1F2";
export const facebookColor = "#3b5998";
export const linkedInColor = "#0e76a8";
export const fallBackProfileImage = DefaultProfilePhoto;
export const APP_DEFAULT_PATH = "/";
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

export enum SimpleLayoutType {
  SIMPLE = "simple",
  LANDING = "landing",
}

export enum ThemeMode {
  LIGHT = "light",
  DARK = "dark",
}

export enum MenuOrientation {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
}

export enum ThemeDirection {
  LTR = "ltr",
  RTL = "rtl",
}

export enum NavActionType {
  FUNCTION = "function",
  LINK = "link",
}

export enum DropzopType {
  DEFAULT = "default",
  STANDARD = "standard",
}

// ==============================|| THEME CONFIG ||============================== //

const config: DefaultConfigProps = {
  fontFamily: `'Public Sans', sans-serif`,
  i18n: "en",
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  container: true,
  mode: ThemeMode.LIGHT,
  presetColor: "default",
  themeDirection: ThemeDirection.LTR,
};

export const ApiBase: string = import.meta.env.VITE_API_URL;

// ==============================|| CLIENT CODE ENUM ||============================== //
export enum ClientCode {
  LocalProject = "Local",
  DSI = "DSI",
  ITMBU = "ITMBU",
  MEU = "MEU",
  SMVIT = "SMVIT",
  GET = "GET",
  RAI = "RAI",
  IAU = "IAU",
  DDU = "DDU",
  PPSU = "PPSU",
  SPU = "SPU",
  Darshan = "Darshan",
  KPGU = "KPGU",
  IAR = "IAR",
  UPL = "UPL",
  JLU = "JLU",
  SJU = "SJU",
  KKS = "KKS",
  GNAlumni = "GNAlumni",
}

// ==============================|| CLIENT URL → CODE MAP ||============================== //
export const ClientUrlMap: Record<string, ClientCode> = {
  "http://localhost:5174": ClientCode.LocalProject,
  "http://localhost:5173": ClientCode.LocalProject,

  "https://alumni-admin.mydsi.org": ClientCode.DSI,
  "https://www.alumni-admin.mydsi.org": ClientCode.DSI,

  "https://alumni-admin.itmbu.ac.in": ClientCode.ITMBU,
  "https://www.alumni-admin.itmbu.ac.in": ClientCode.ITMBU,

  "https://meu-admin.gnalumni.com": ClientCode.MEU,
  "https://www.meu-admin.gnalumni.com": ClientCode.MEU,

  "https://admin.sirmvitalumni.com": ClientCode.SMVIT,
  "https://www.admin.sirmvitalumni.com": ClientCode.SMVIT,

  "https://admin.alumni.geetanjaliuniversity.com": ClientCode.GET,
  "https://www.admin.alumni.geetanjaliuniversity.com": ClientCode.GET,

  "https://admin.raialumni.gnums.co.in": ClientCode.RAI,
  "https://www.admin.raialumni.gnums.co.in": ClientCode.RAI,

  "https://admin.indrashilalumni.gnums.co.in": ClientCode.IAU,
  "https://www.admin.indrashilalumni.gnums.co.in": ClientCode.IAU,

  "https://admin.ddu.gnalumni.com": ClientCode.DDU,
  "https://www.admin.ddu.gnalumni.com": ClientCode.DDU,

  "https://admin.ppsu.gnalumni.com": ClientCode.PPSU,
  "https://www.admin.ppsu.gnalumni.com": ClientCode.PPSU,

  "https://adminalumni.spu.ac.in": ClientCode.SPU,
  "https://www.adminalumni.spu.ac.in": ClientCode.SPU,

  "https://admin.darshanalumni.in": ClientCode.Darshan,
  "https://www.admin.darshanalumni.in": ClientCode.Darshan,

  "https://adminalumni.kpgu.ac.in": ClientCode.KPGU,
  "https://www.adminalumni.kpgu.ac.in": ClientCode.KPGU,

  "https://adminalumni.iar.ac.in": ClientCode.IAR,
  "https://www.adminalumni.iar.ac.in": ClientCode.IAR,

  "https://adminalumni.upluniversity.ac.in": ClientCode.UPL,
  "https://www.adminalumni.upluniversity.ac.in": ClientCode.UPL,

  "https://adminalumni.jlu.edu.in": ClientCode.JLU,

  "https://adminalumni.sanjivani.edu.in": ClientCode.SJU,
  "https://www.adminalumni.sanjivani.edu.in": ClientCode.SJU,

  "https://adminkksheth.gnalumni.in": ClientCode.KKS,

  "https://admindemo.gnalumni.com": ClientCode.GNAlumni,
  "https://www.admindemo.gnalumni.com": ClientCode.GNAlumni,
};

// ==============================|| CLIENT BRANDING TYPE ||============================== //
type ClientBranding = {
  loginBackImg?: string;
  smallLogo: string;
  fullLogo?: string;
  shortName: string;
  themeColor: string;
};

// ==============================|| CLIENT BRANDING BY CODE ||============================== //
const ClientBrandingByCode: Record<ClientCode, ClientBranding> = {
  [ClientCode.LocalProject]: {
    loginBackImg:
      "https://dvyqp9hjyyds.cloudfront.net/Images/login-back-upl.jpg",
    smallLogo:
      "https://dvyqp9hjyyds.cloudfront.net/Upload/Logo/UPL_SmallLogo.png",
    fullLogo:
      "https://dvyqp9hjyyds.cloudfront.net/Upload/Logo/UPL_FullLogo.png",
    shortName: "GN",
    themeColor: "#035199",
  },
  [ClientCode.DSI]: {
    loginBackImg: "https://d3fb03zx5h21st.cloudfront.net/Images/login-back.jpg",
    smallLogo:
      "https://d3fb03zx5h21st.cloudfront.net/Upload/Logo/DSI_Small.png",
    fullLogo:
      "https://d3fb03zx5h21st.cloudfront.net/Upload/Logo/DSI_Full-logo.png",
    shortName: "DSI",
    themeColor: "#1194d1",
  },
  [ClientCode.ITMBU]: {
    loginBackImg:
      "https://d1f11tvnfjqryd.cloudfront.net/Images/login-back-ITMBU.jpg",
    smallLogo: "https://d1f11tvnfjqryd.cloudfront.net/Images/ITMBU_Logo.png",
    fullLogo: "https://d1f11tvnfjqryd.cloudfront.net/Images/ITMBU_Logo.png",
    shortName: "ITMBU",
    themeColor: "#b33425",
  },
  [ClientCode.MEU]: {
    loginBackImg:
      "https://d3a4jls59ro43h.cloudfront.net/Images/login-back-MEU.jpg",
    smallLogo:
      "https://d3a4jls59ro43h.cloudfront.net/Upload/Logo/MEU_SmallLogo.png",
    fullLogo:
      "https://d3a4jls59ro43h.cloudfront.net/Upload/Logo/Meu_LargeLogo.jpg",
    shortName: "MEU",
    themeColor: "#d94814",
  },
  [ClientCode.SMVIT]: {
    loginBackImg:
      "https://d3t0f9jpt2fds8.cloudfront.net/Images/login-back-SMVIT.jpg",
    smallLogo:
      "https://d3t0f9jpt2fds8.cloudfront.net/Upload/Logo/SMVIT_SmallLogo.png",
    fullLogo:
      "https://d3t0f9jpt2fds8.cloudfront.net/Upload/Logo/SirMVIT_Alumni_Logo.png",
    shortName: "SMVIT",
    themeColor: "#fc5378",
  },
  [ClientCode.GET]: {
    loginBackImg:
      "https://d1ravyl4xj14l2.cloudfront.net/Images/login-back-geetanjali.jpg",
    smallLogo:
      "https://d1ravyl4xj14l2.cloudfront.net/Upload/Logo/Geetanjali_SmallLogo.png",
    fullLogo:
      "https://d1ravyl4xj14l2.cloudfront.net/Upload/Logo/Geetanjali_FullLogo.png",
    shortName: "GU",
    themeColor: "#f05157",
  },
  [ClientCode.RAI]: {
    loginBackImg:
      "https://d3nbc713tplvd1.cloudfront.net/Images/login-back-Rai.jpg",
    smallLogo:
      "https://d3nbc713tplvd1.cloudfront.net/Upload/Logo/Rai_SmallLogo.png",
    fullLogo:
      "https://d3nbc713tplvd1.cloudfront.net/Upload/Logo/Rai_FullLogo.png",
    shortName: "Rai",
    themeColor: "#f58433",
  },
  [ClientCode.IAU]: {
    loginBackImg:
      "https://d2beora143tsok.cloudfront.net/Images/login-back-IU.jpg",
    smallLogo:
      "https://d2beora143tsok.cloudfront.net/Upload/Logo/IU_SmallLogo.png",
    fullLogo:
      "https://d2beora143tsok.cloudfront.net/Upload/Logo/IU_FullLogo.png",
    shortName: "IU",
    themeColor: "#0368ab",
  },
  [ClientCode.DDU]: {
    loginBackImg:
      "https://d39itv4llo32q2.cloudfront.net/Images/login-back-DDU.jpg",
    smallLogo:
      "https://d39itv4llo32q2.cloudfront.net/Upload/Logo/DDU_SmallLogo.png",
    fullLogo:
      "https://d39itv4llo32q2.cloudfront.net/Upload/Logo/DDU_FullLogo.png",
    shortName: "DDU",
    themeColor: "#f27a11",
  },
  [ClientCode.PPSU]: {
    loginBackImg:
      "https://d3kn6hul7bzdxk.cloudfront.net/Images/login-back-ppsu.jpg",
    smallLogo:
      "https://d3kn6hul7bzdxk.cloudfront.net/Upload/Logo/PPSU_SmallLogo.jpg",
    fullLogo:
      "https://d3kn6hul7bzdxk.cloudfront.net/Upload/Logo/PPSU_FullLogo.png",
    shortName: "PPSU",
    themeColor: "#db181f",
  },
  [ClientCode.SPU]: {
    loginBackImg:
      "https://dtkndyxh10o5g.cloudfront.net/Images/login-back-spu.jpg",
    smallLogo:
      "https://dtkndyxh10o5g.cloudfront.net/Upload/Logo/Spu_SmallLogo.png",
    fullLogo:
      "https://dtkndyxh10o5g.cloudfront.net/Upload/Logo/Spu_FullLogo.png",
    shortName: "SPU",
    themeColor: "#295773",
  },
  [ClientCode.Darshan]: {
    loginBackImg:
      "https://dgjehusiipf3v.cloudfront.net/Images/login-back-darshan.jpg",
    smallLogo:
      "https://dgjehusiipf3v.cloudfront.net/Upload/Logo/Darshan_SmallLogo.png",
    fullLogo:
      "https://dgjehusiipf3v.cloudfront.net/Upload/Logo/Darshan_FullLogo.png",
    shortName: "DU",
    themeColor: "#d61c3e",
  },
  [ClientCode.KPGU]: {
    loginBackImg:
      "https://d233t0zhzz6dz3.cloudfront.net/Images/login-back-kpgu.jpg",
    smallLogo:
      "https://d233t0zhzz6dz3.cloudfront.net/Upload/Logo/KPGU_SmallLogo.jpg",
    fullLogo:
      "https://d233t0zhzz6dz3.cloudfront.net/Upload/Logo/KPGU_FullLogo.png",
    shortName: "KPGU",
    themeColor: "#264796",
  },
  [ClientCode.IAR]: {
    loginBackImg:
      "https://dht7rgf4zuxt3.cloudfront.net/Images/login-back-iar.png",
    smallLogo:
      "https://dht7rgf4zuxt3.cloudfront.net/Upload/Logo/IAR_SmallLogo.png",
    fullLogo:
      "https://dht7rgf4zuxt3.cloudfront.net/Upload/Logo/IAR_FullLogo.jpg",
    shortName: "IAR",
    themeColor: "#850346",
  },
  [ClientCode.UPL]: {
    loginBackImg:
      "https://dvyqp9hjyyds.cloudfront.net/Images/login-back-upl.jpg",
    smallLogo:
      "https://dvyqp9hjyyds.cloudfront.net/Upload/Logo/UPL_SmallLogo.png",
    fullLogo:
      "https://dvyqp9hjyyds.cloudfront.net/Upload/Logo/UPL_FullLogo.png",
    shortName: "UPL",
    themeColor: "#538ac9",
  },
  [ClientCode.JLU]: {
    loginBackImg:
      "https://d3vddhrk136a9v.cloudfront.net/Images/login-back-jlu.jpg",
    smallLogo:
      "https://d3vddhrk136a9v.cloudfront.net/Upload/Logo/JLU_SmallLogo.jpg",
    fullLogo:
      "https://d3vddhrk136a9v.cloudfront.net/Upload/Logo/JLU_FullLogo.png",
    shortName: "JLU",
    themeColor: "#03809B",
  },
  [ClientCode.SJU]: {
    loginBackImg:
      "https://d2blncg21927me.cloudfront.net/Images/login-back-sju.jpg",
    smallLogo:
      "https://d2blncg21927me.cloudfront.net/Upload/Logo/SJU_SmallLogo.jpg",
    fullLogo:
      "https://d2blncg21927me.cloudfront.net/Upload/Logo/SJU_FullLogo.png",
    shortName: "SJU",
    themeColor: "#233857",
  },
  [ClientCode.KKS]: {
    loginBackImg:
      "https://d1gip6uqspfiv6.cloudfront.net/Images/login-back-KKSeth.jpg",
    smallLogo:
      "https://d1gip6uqspfiv6.cloudfront.net/Upload/Logo/KKSeth_SmallLogo.jpg",
    fullLogo:
      "https://d1gip6uqspfiv6.cloudfront.net/Upload/Logo/KKSeth_FullLogo.jpg",
    shortName: "KKSPTC",
    themeColor: "#223B73",
  },
  [ClientCode.GNAlumni]: {
    loginBackImg:
      "https://d3vddhrk136a9v.cloudfront.net/Images/login-back-jlu.jpg",
    smallLogo:
      "https://diba6h158qrm3.cloudfront.net/Logo/gnLibLogo.png",
      // "https://d2ocuppja9d4fr.cloudfront.net/Upload/Logo/Darshan_SmallLogo.png",
    fullLogo:
      "https://d2ocuppja9d4fr.cloudfront.net/Upload/Events/a064805a-7080-48bb-870a-382a2c690824.png",
      // "https://d2ocuppja9d4fr.cloudfront.net/Upload/Logo/Darshan_FullLogo.png",
    shortName: "GNWebsoft",
    themeColor: "#1194d1",
  },
};

// ==============================|| RESOLVE CLIENT ||============================== //
export const getClientCodeFromUrl = (url: string): ClientCode | null =>
  ClientUrlMap[url] ?? null;

const resolveClientBranding = (): ClientBranding => {
  const origin = window.location.origin;
  const clientCode = getClientCodeFromUrl(origin);

  return (
    (clientCode && ClientBrandingByCode[clientCode]) ??
    ClientBrandingByCode[ClientCode.LocalProject]
  );
};

// ==============================|| DYNAMIC CLIENT EXPORTS ||============================== //
const client = resolveClientBranding();

export const LoginBackImg = client.loginBackImg;
export const SmallLogo = client.smallLogo;
export const FullLogo = client.fullLogo ?? client.smallLogo;
export const ShortName = client.shortName;
export const ThemeColor = client.themeColor;

export default config;
